import Config from '../definitions/Config';

/**
 * Checks whether we are inside a widget.
 * Formerly, this was based on determining if we had loaded the iframe-resizer library,
 * which proved unreliable because of lazy loading that made it false on initial page load.
 * As of now, it is based solely on Config.ENABLE_WIDGET_LOADER which now assumes
 * it is enabled ONLY for /gizmos/loader.
 *
 * @returns {boolean}
 */
export default function isWidget() {
    if (typeof window === 'undefined') {
        return false;
    } else {
        return !!Config.ENABLE_WIDGET_LOADER;
    }
}
